import Reservations from './Reservations'

export default Reservations
